import adminGuard from '@/router/guards/admin-guard'
import multiGuard from '@/router/utils/vue-router-multiguard'
import authGuard from '@/router/guards/auth-guard'
import checkTokenGuard from '@/router/guards/check-token-guard'

const adminRoutes = [
  {
    path: '/admin',
    component: () => import(/* webpackChunkName: "super-admin" */ '@/layouts/full/LayoutFull.vue'),
    beforeEnter: multiGuard([checkTokenGuard, authGuard, adminGuard]),
    children: [
      {
        path: '/',
        name: 'admin:home',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/admin/statistics/Statistics.vue'),
      },
      {
        path: 'pages',
        name: 'admin:pages',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/admin/pages/PagesTable.vue'),
      },
      {
        path: 'insta-accounts',
        name: 'admin:insta-accounts',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/admin/pages/InstagramAccountsTable.vue'),
      },
      {
        path: 'accounts',
        name: 'admin:accounts',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/admin/users/UsersTable.vue'),
      },
      {
        path: 'push-notifications',
        name: 'admin:push-notifications',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/admin/users/PushNotifications.vue'),
      },
      {
        path: 'receipts',
        name: 'admin:receipts',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/admin/invoices/InvoicesTable.vue'),
      },
      {
        path: 'plans',
        name: 'admin:plans',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/admin/plans/PlansTable.vue'),
      },
      {
        path: 'help',
        name: 'admin:help',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/admin/help/HelpSectionsTable.vue'),
      },
      {
        path: 'help/sections/:id',
        name: 'super:help-section',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/admin/help/HelpQuestionsTable.vue'),
      },
      {
        path: 'replies/fb',
        name: 'admin:fb-replies',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/admin/general/FbReportsTable.vue'),
      },
      {
        path: 'replies/instagram',
        name: 'admin:instagram-replies',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/admin/general/InstagramReportsTable.vue'),
      },
      {
        path: 'commenter/list',
        name: 'admin:commenter-list',
        component: () => import(/* webpackChunkName: "commenter" */ '@/views/admin/pages/CommentersListTable.vue'),
      },
      {
        path: 'liker/list',
        name: 'admin:liker-list',
        component: () => import(/* webpackChunkName: "commenter" */ '@/views/admin/pages/LikersListTable.vue'),
      },
      {
        path: 'errors/list',
        name: 'admin:errors-list',
        component: () => import(/* webpackChunkName: "commenter" */ '@/views/admin/pages/ErrorsListTable.vue'),
      },
      {
        path: 'pages/accounts',
        name: 'admin:page-accounts',
        component: () => import(/* webpackChunkName: "commenter" */ '@/views/admin/pages/PagesAccountsListTable.vue'),
      },
      {
        path: 'n8n-pages',
        name: 'admin:n8n-pages',
        component: () => import(/* webpackChunkName: "n8n" */ '@/views/admin/pages/N8nPages.vue'),
      },
      {
        path: 'n8n-pages/history',
        name: 'admin:n8n-pages-history',
        component: () => import(/* webpackChunkName: "n8n" */ '@/views/admin/pages/N8nPagesHistoryTable.vue'),
      },
      {
        path: 'n8n-instagram-accounts',
        name: 'admin:n8n-instagram-accounts',
        component: () => import(/* webpackChunkName: "n8n" */ '@/views/admin/pages/N8nInstagramAccounts.vue'),
      },
      {
        path: 'n8n-instagram-accounts/history',
        name: 'admin:n8n-instagram-history',
        component: () => import(/* webpackChunkName: "n8n" */ '@/views/admin/pages/N8nInstagramPostsHistoryTable.vue'),
      },
    ],
  },
]

export default adminRoutes
